export const BREAKPOINT_COLUMNS = {
  default: 3,
  1600: 3,
  1200: 2,
  800: 1,
};
